export default "__VITE_ASSET__BUPb4R3a__"